import { Injectable } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { GeometricFormType } from 'src/app/geometrics-form/state/geometric-form.type';
import { Vertex } from 'src/app/geometrics-form/vertexes/state/vertex.model';
import { VertexFormComponent } from 'src/app/geometrics-form/vertexes/vertex-form/vertex-form.component';
import { MapService } from 'src/app/shared/components/map/map.service';
import { FeatureDragingDropService } from '../actions/layer-actions/feature-draging-drop.service';
import { FeatureSelectionService } from '../actions/layer-actions/feature-selection.service';
import { FeatureOpenService } from '../actions/layer-actions/feature-open.service';
import { vertexToFeature } from '../mappers/geojon-mapper';
import { Plotter } from './plotter';

@Injectable({
  providedIn: 'root'
})
export class VertexPlotter extends Plotter<Vertex> {

  type: GeometricFormType = 'mitra-vertex';

  mapper = vertexToFeature;

  constructor(
    protected mapService: MapService,
    protected openService: FeatureOpenService,
    protected selectionService: FeatureSelectionService,
    protected dragingDropService: FeatureDragingDropService,
  ) {
    super([selectionService, dragingDropService]);
    mapService.map$.subscribe(m => {
      this.init(m);
      this.openService.listen(
        m,
        {
          title: $localize`EDIT VERTEX`,
          layerName: this.type,
          componentType: VertexFormComponent
        }
      );
    });
    this.openService.active = true;
  }

  layer: mapboxgl.Layer = {
    id: this.type,
    type: 'circle',
    source: this.type,
    paint: {
      'circle-color':
        ['case',
          [
            'boolean',
            ['get', 'invalid'],
            false
          ],
          '#ff0000',
          [
            'match',
            ['get', 'map_legend'],
            'CO',
            '#5cb85c',
            'PL',
            '#3effe8',
            'PL End of line',
            '#3effe8',
            'AC',
            '#f0ad4e',
            'UB',
            '#f0ad4e',
            '#ff0000'
          ]
        ],
      'circle-radius': [
        'interpolate',
        ['linear'],
        ['zoom'],
        1,
        1,
        10,
        1,
        15,
        5,
        20,
        15,
        22,
        30
      ],
      'circle-stroke-width': [
        'case',
        ['boolean',
          ['feature-state', 'm_selected'],
          false
        ],
        STROKE_WIDTH * 2,
        ['match',
          ['get', 'map_legend'],
          'PL End of line',
          STROKE_WIDTH,
          'UB',
          STROKE_WIDTH,
          0
        ]
      ],
      'circle-opacity': [
        'match',
        ['get', 'map_legend'],
        'PL End of line',
        0,
        'UB',
        0,
        ['case',
          [
            'boolean',
            ['feature-state', 'm_dragin'],
            false
          ],
          0.2,
          [
            'boolean',
            ['feature-state', 'm_hover'],
            false
          ],
          1,
          ['case',
            [
              'boolean',
              ['feature-state', 'm_selected'],
              false,
            ],
            1,
            0.7
          ]
        ]
      ],
      'circle-stroke-color':
        ['case',
          [
            'boolean',
            ['get', 'invalid'],
            false
          ],
          '#ff0000',
          [
            'match',
            ['get', 'map_legend'],
            'CO',
            '#5cb85c',
            'PL',
            '#3effe8',
            'PL End of line',
            '#3effe8',
            'AC',
            '#f0ad4e',
            'UB',
            '#f0ad4e',
            '#ff0000'
          ]
        ],
      'circle-stroke-opacity': [
        'case',
        [
          'boolean',
          ['feature-state', 'm_selected'],
          false,
        ],
        1,
        ['case',
          [
            'boolean',
            ['feature-state', 'm_hover'],
            false
          ],
          1,
          0.7
        ]
      ]
    }
  };
}

const STROKE_WIDTH = 2;
